import {Component, ViewEncapsulation, ChangeDetectorRef, OnDestroy, OnInit} from '@angular/core';
import { Settings } from '../../config/settings.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'not-found-page',
    templateUrl: './not-found-page.component.html',
    styleUrls: ['./not-found-page.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class NotFoundPageComponent implements OnInit, OnDestroy {
    private sub: Subscription;

    constructor(
        public settings: Settings,
        private changeDetection: ChangeDetectorRef
    ) {}

    ngOnInit() {
        this.sub = this.settings.onChange.subscribe(() => {
            this.changeDetection.detectChanges();
        });
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}
